import { render, staticRenderFns } from "./ItemLimitsSaleLayout.vue?vue&type=template&id=1ae7e710&scoped=true&"
import script from "./ItemLimitsSaleLayout.vue?vue&type=script&lang=js&"
export * from "./ItemLimitsSaleLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae7e710",
  null
  
)

export default component.exports